export default "__VITE_ASSET__TwHyH8UH__"